import type { MetricItem } from "@/lib/types";

export default function Metrics({ data }: { data: MetricItem[] }) {
  return (
    <section className="metrics">
      <div className="metrics-inner">
        {data.map((m) => (
          <div className="metric" key={m.label}>
            <div className="metric-num">{m.num}</div>
            <div className="metric-label">{m.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
